// eslint-disable-next-line no-restricted-imports
import { useEffect, useLayoutEffect } from "react";

/**
 * useLayoutEffect имеет смысл использовать только в клиентских компонентах.
 * Если хук попадает в серверный рендеринг, он может повлечь за собой несоответствия вёрстки и ошибки гидратации.
 */
export const useIsomorphicLayoutEffect =
    typeof window.document === "undefined" ? useEffect : useLayoutEffect;
